var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _a;
import { IsArray, IsEnum, IsNotEmpty, IsOptional, IsString, ValidateIf, ValidateNested, } from "class-validator";
import { Type } from "class-transformer";
import { BlockOptions, CheckboxOptions, InputOptions, LinkOptions, IntegrationOptions, MapOptions, PresetOptions, RadioOptions, SelectOptions, SubtitleOptions, TextAreaOptions, TitleOptions, UploadOptions, ArrayOptions, TableOptions, } from "./options.interface";
export var FieldTypeEnum;
(function (FieldTypeEnum) {
    FieldTypeEnum["Array"] = "array";
    FieldTypeEnum["Block"] = "block";
    FieldTypeEnum["Checkbox"] = "checkbox";
    FieldTypeEnum["Input"] = "input";
    FieldTypeEnum["Integration"] = "integration";
    FieldTypeEnum["Link"] = "link";
    FieldTypeEnum["Map"] = "map";
    FieldTypeEnum["Preset"] = "preset";
    FieldTypeEnum["Radio"] = "radio";
    FieldTypeEnum["Select"] = "select";
    FieldTypeEnum["Subtitle"] = "subtitle";
    FieldTypeEnum["Table"] = "table";
    FieldTypeEnum["Textarea"] = "textarea";
    FieldTypeEnum["Title"] = "title";
    FieldTypeEnum["Upload"] = "upload";
})(FieldTypeEnum || (FieldTypeEnum = {}));
var FieldOptionsTypeDict = (_a = {},
    _a[FieldTypeEnum.Array] = ArrayOptions,
    _a[FieldTypeEnum.Block] = BlockOptions,
    _a[FieldTypeEnum.Checkbox] = CheckboxOptions,
    _a[FieldTypeEnum.Input] = InputOptions,
    _a[FieldTypeEnum.Integration] = IntegrationOptions,
    _a[FieldTypeEnum.Link] = LinkOptions,
    _a[FieldTypeEnum.Map] = MapOptions,
    _a[FieldTypeEnum.Preset] = PresetOptions,
    _a[FieldTypeEnum.Radio] = RadioOptions,
    _a[FieldTypeEnum.Select] = SelectOptions,
    _a[FieldTypeEnum.Subtitle] = SubtitleOptions,
    _a[FieldTypeEnum.Table] = TableOptions,
    _a[FieldTypeEnum.Textarea] = TextAreaOptions,
    _a[FieldTypeEnum.Title] = TitleOptions,
    _a[FieldTypeEnum.Upload] = UploadOptions,
    _a);
export function getOptionsClass(type) {
    return FieldOptionsTypeDict[type];
}
var IFieldExpressions = /** @class */ (function () {
    function IFieldExpressions() {
    }
    __decorate([
        IsString(),
        IsOptional()
    ], IFieldExpressions.prototype, "model", void 0);
    __decorate([
        IsString(),
        IsOptional()
    ], IFieldExpressions.prototype, "modelDescription", void 0);
    __decorate([
        IsString(),
        IsOptional()
    ], IFieldExpressions.prototype, "visible", void 0);
    __decorate([
        IsString(),
        IsOptional()
    ], IFieldExpressions.prototype, "valid", void 0);
    __decorate([
        IsString(),
        IsOptional()
    ], IFieldExpressions.prototype, "integration", void 0);
    __decorate([
        IsString(),
        IsOptional()
    ], IFieldExpressions.prototype, "options", void 0);
    __decorate([
        IsString(),
        IsOptional()
    ], IFieldExpressions.prototype, "log", void 0);
    return IFieldExpressions;
}());
export { IFieldExpressions };
var IField = /** @class */ (function () {
    function IField() {
    }
    __decorate([
        IsNotEmpty(),
        IsEnum(FieldTypeEnum)
    ], IField.prototype, "type", void 0);
    __decorate([
        ValidateIf(function (obj) {
            var specifiedValues = [FieldTypeEnum.Title, FieldTypeEnum.Subtitle];
            return !specifiedValues.includes(obj.type);
        }),
        IsString()
    ], IField.prototype, "key", void 0);
    __decorate([
        IsNotEmpty(),
        ValidateNested(),
        Type(function (data) { return getOptionsClass(data.object.type); })
    ], IField.prototype, "options", void 0);
    __decorate([
        ValidateNested({ each: true }),
        Type(function () { return IFieldExpressions; })
    ], IField.prototype, "expressions", void 0);
    __decorate([
        IsOptional(),
        IsArray(),
        ValidateNested({ each: true }),
        Type(function () { return IField; })
    ], IField.prototype, "block", void 0);
    __decorate([
        IsOptional(),
        IsArray(),
        ValidateNested({ each: true }),
        Type(function () { return IField; })
    ], IField.prototype, "preset", void 0);
    return IField;
}());
export { IField };
